<template>
  <div class="edit-site">
    <el-form :model="siteData" :rules="validators" ref="siteData" label-width="200px" class="edit-site-form">
      
      <el-form-item label="Name" prop="name">
        <el-input v-model="siteData.name"></el-input>
      </el-form-item>

      <el-form-item label="Address" prop="address">
        <el-input v-model="siteData.address"></el-input>
      </el-form-item>

      <el-form-item label="Latitude" prop="lat">
        <el-input v-model="siteData.latitude"></el-input>
      </el-form-item>

      <el-form-item label="Longitude" prop="long">
        <el-input v-model="siteData.longitude"></el-input>
      </el-form-item>

      <el-form-item label="Zoom" prop="zoom">
        <el-input v-model="siteData.zoom"></el-input>
      </el-form-item>

      <el-form-item label="Auto Off Time" prop="off_time">
        <el-input v-model="siteData.auto_off_time"></el-input>
      </el-form-item>

      <el-form-item label="Standby" prop="standby">
        <el-input-number v-model="siteData.standby"></el-input-number> Minutes
      </el-form-item>

      <div class="separator"></div>
      
      <el-form-item label="Power Relay" prop="power_relay" style="align: left;">
        <el-select v-model="siteData.power_relay" placeholder="Power Relay">
          <el-option 
              v-for="device in devices"
              :key="device.id"
              :label="device.name"
              :value="device.id">
          </el-option>
        </el-select>
      </el-form-item>
      <div v-if="siteData.power_relay > 0">
        <el-form-item label="Logical" style="align: left;">
          <el-select v-model="siteData.logical_no" placeholder="Logical no">
            <el-option 
              v-for="logical in logicals"
              :key="logical.logical_no"
              :label="logical.logical_no"
              :value="logical.logical_no">
          </el-option>
          </el-select>
        </el-form-item>
      
        <el-form-item label="Delay" prop="delay">
          <el-input-number v-model="siteData.delay"></el-input-number> Seconds
        </el-form-item>
      </div>
      
      <div class="separator"></div>

      <el-form-item label="Contact Name" prop="contact.name">
        <el-input v-model="siteData.contact.name"></el-input>
      </el-form-item>

      <el-form-item label="Contact Phone" prop="contact.phone">
        <el-input v-model="siteData.contact.phone"></el-input>
      </el-form-item>

      <el-form-item label="Contact Email" prop="contact.email">
        <el-input v-model="siteData.contact.email"></el-input>
      </el-form-item>

    
      <el-form-item>
        <el-button type="save" @click="submit('siteData')">Save</el-button>
        <el-button type="cancel" @click="close">Cancel</el-button>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
import auth from '../../../auth';
import requests from '../../../requests';

export default {
  name: 'admin-edit-site',
  props:['siteData'],
  data () {
    
    var validateEmail = (rule, value, callback) => {
      var emailRegex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      if(!value.trim().match(emailRegex)) {
        callback(new Error("Not a valid email address."));
      }
      callback();
    };

    return {
      pageName: 'Edit Site',
      userIsSuperAdmin: false,
      validators: {
        email: [
          { required: true, message: "Please input an email.", trigger: 'blur'},    
          { min:2, max: 99, message: "Must be between 2-99 characters.", trigger: 'blur' },
          { validator: validateEmail }
        ],
      },
      devices:[],
      logicals:[]
    }
  },
  methods: {
    editSite(){
      var siteData = this.siteData;

      var context = this;
      var site_id = siteData.id;

      requests.updateSite(this, siteData, site_id, function (result) {
        if(result.action === 'success'){
          context.$message({
            showClose: true,
            type: 'success',
            message: 'Successfully edited site ' + siteData.name
          });

          context.close();

        } else {

          context.$message({
            showClose: true,
            type: 'error',
            message: 'Failed to edited site: ' + result.msg,
          });
        }
      });

    },
    submit(formName) {

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editSite();
          this.reset(formName);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    reset(formName) {
      this.$refs[formName].resetFields();
    },
    close() {
      this.reset('siteData');
      this.$emit('close');
    }
  },
  beforeMount() {
    var context = this;
    var profile = JSON.parse(auth.getProfile());
    this.userIsSuperAdmin = (profile.role === 3);

    if(!this.siteData.power_relay){
      this.powerRelay = -1;
    }
    requests.getDevices(this, function(result){
      context.devices = result.data;
      context.devices.push({id: -1, name:'None'});
    });
  },
  watch: {
    'siteData.power_relay':function(val){
      if(!val || val < 1){
        return false;
      }
      var context = this;
      requests.getDeviceRelays(this, val, function(result){
        context.logicals = result.data;
      });
    }
  }
}
</script>

<style>

  .separator {
    border-bottom: 1px #dddddd solid;
    margin-bottom: 20px;
  }

</style>



// WEBPACK FOOTER //
// EditSite.vue?aa06da12